<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  export interface FieldStackLabelProps {
    class?: HTMLAttributes['class']
    label?: string
  }
</script>

<script setup lang="ts">
  import FieldLabel from '../fields/FieldLabel.vue'
  import FieldStack from '../fields/FieldStack.vue'
  import { useGatForm } from '../gat-form/gat-form.vue'
  import { cn } from '../../lib/utils'
  const formContext = useGatForm()

  const props = defineProps<FieldStackLabelProps>()
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="flex items-end gap-0.5">
      <FieldLabel>
        <slot name="label">
          {{ label }}
        </slot>
      </FieldLabel>
      <slot name="label-append" />
    </div>
    <FieldStack>
      <slot />
    </FieldStack>
  </div>
</template>
